export default __webpack_public_path__ + "static/media/factory_red.f5a0ace2.svg";